// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"0027d688","113":"a959eb82","137":"2836879c","180":"c95d688a","183":"873cd42f","213":"efdf2d78","343":"930ddfda","455":"3f4a07b6","481":"70d8ee0b","488":"f1dc7667","758":"fb3c14f0","941":"efdc8f27"}[chunkId] + ".chunk.js";
};